import axios from 'axios';

export const tokenAxios = () => {
  const instance = axios.create({});

  instance.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${sessionStorage.getItem('token') ?? ""}`;
    return config;
  });

  return instance;
};
